<template>
  <div>
    <el-form
      class="add-form"
      @submit.prevent="checkTaxInformation"
      @keydown.enter.prevent="() => {}"
      :model="tax"
      label-position="top"
      ref="taxForm"
    >
      <!-- Row 1: Organization -->
      <div class="row"
      v-if="
        showOrganization &&
        $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
      ">
        <div class="col-md-12 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('COMMON.ORGANIZATION')} (*)`"
            prop="organization.id"
            :rules="[
              {
                required: true,
                message: $t('COMMON.ORGANIZATION_REQUIRED'),
              },
            ]"
          >
            <organization-selector
              :organization="tax.organization.id"
              :filterable="true"
              :showAll="false"
              @organizationChanged="
                (organizationId) => {
                  tax.organization.id = organizationId;
                  onFormChanged();
                }
              "
            />
            <validation-error :errors="apiValidationErrors.organization" />
          </el-form-item>
        </div>
      </div>
      <!-- Row 1: Name + Denomination -->
      <div class="row">
        <div class="col-md-6 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('COMMON.NAME')} (*)`"
            prop="name"
            :rules="[
              {
                required: true,
                message: $t('TAXES.NAME_REQUIRED'),
              },
            ]"
          >
            <base-input
              :placeholder="$t('COMMON.NAME')"
              v-model="tax.name"
              @change="
                () => {
                  onFormChanged();
                }
              "
            />
            <validation-error :errors="apiValidationErrors.name" />
          </el-form-item>
        </div>
        <div class="col-md-6 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('TAXES.DENOMINATION')} (*)`"
            prop="label"
            :rules="[
              {
                required: true,
                message: $t('TAXES.DENOMINATION_REQUIRED'),
              },
            ]"
          >
            <base-input
              :placeholder="$t('TAXES.DENOMINATION')"
              v-model="tax.label"
              @change="
                () => {
                  onFormChanged();
                }
              "
            />
            <validation-error :errors="apiValidationErrors.label" />
          </el-form-item>
        </div>
      </div>


      <!-- Row 4: Calculation Type + Value -->
      <div class="row">
        <div class="col-md-6 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('TAXES.CALCULATION_TYPE')} (*)`"
            prop="calculation_type"
            :rules="[
              {
                required: true,
                message: $t('TAXES.TYPE_REQUIRED'),
              },
            ]"
          >
            <el-select
              v-model="tax.calculation_type"
              :placeholder="$t('TAXES.CALCULATION_TYPE')"
            >
              <el-option
                v-for="(taxType, val) in taxeTypes"
                :key="val"
                :value="val"
                :label="`${val ? $t('TAXES.' + val) : ''}`"
              />
            </el-select>
            <validation-error :errors="apiValidationErrors.calculation_type" />
          </el-form-item>
        </div>
        <div class="col-md-6 form-wrapper p-2">
          <el-form-item
            class="form-group "
            prop="value"
            :label="
              tax.calculation_type == typeMontantFixe
                ? `${$t('TAXES.AMOUNT')} (*)`
                : `${$t('TAXES.PERCENTAGE')} (*)`
            "
            :rules="[
              {
                required: true,
                message:
                  tax.calculation_type == typeMontantFixe
                    ? $t('TAXES.AMOUNT_REQUIRED')
                    : $t('TAXES.PERCENTAGE_REQUIRED'),
              },
            ]"
          >
            <base-input
              :placeholder="
                tax.calculation_type == typeMontantFixe
                  ? $t('TAXES.AMOUNT')
                  : $t('TAXES.PERCENTAGE')
              "
              type="number"
              v-model="tax.value"
              @change="
                () => {
                  onFormChanged();
                }
              "
            />
            <validation-error :errors="apiValidationErrors.value" />
          </el-form-item>
        </div>
      </div>

      <!--Tax Number -->
      <div class="row">
        <div class="col-md-4 form-wrapper p-2">
          <el-form-item
            class=""
            :label="$t('TAXES.TAX_NUMBER')"
            prop="tax_number"
          >
            <base-input
              :placeholder="$t('TAXES.TAX_NUMBER')"
              v-model="tax.tax_number"
              @change="
                () => {
                  onFormChanged();
                }
              "
            />
            <validation-error :errors="apiValidationErrors.tax_number" />
          </el-form-item>
        </div>
        <div class="col-md-4 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('TAXES.TRANSACTION')} (*)`"
            prop="tax_type"
            :rules="[
              {
                required: true,
                message: $t('TAXES.TRANSACTION_REQUIRED'),
              },
            ]"
          >
            <el-select
              :placeholder="$t('TAXES.TRANSACTION')"
              v-model="tax.tax_type"
            >
              <el-option
                v-for="(transaction, val) in taxeTransactions"
                :key="val"
                :value="val"
                :label="`${val ? $t('TAXES.' + val) : ''}`"
              />
            </el-select>
            <validation-error :errors="apiValidationErrors.tax_type" />
          </el-form-item>
        </div>
        <div class="col-md-4 form-wrapper p-2">
          <el-form-item
            class="form-group "
            :label="`${$t('TAXES.CALCULATION_BASE')} (*)`"
            prop="calculation_base"
            :rules="[
              {
                required: true,
                message: $t('TAXES.CALCULATION_BASE_REQUIRED'),
              },
            ]"
          >
            <el-select
              :placeholder="$t('TAXES.CALCULATION_BASE')"
              v-model="tax.calculation_base"
            >
              <el-option
                v-for="(calcul, val) in calculationBases"
                :key="val"
                :value="val"
                :label="`${val ? $t('TAXES.' + val) : ''}`"
              />
            </el-select>
            <validation-error :errors="apiValidationErrors.calculation_base" />
          </el-form-item>
        </div>
      </div>

      <!-- Row 5: Activation -->
      <div class="row">
        <div class="col-md-12 form-wrapper p-2">
          <el-form-item
            class=""
            :label="$t('TAXES.ACTIVATION')"
            prop="active"
          >
            <el-checkbox v-model="tax.active">{{
              $t("TAXES.ACTIVE")
            }}</el-checkbox>
          </el-form-item>
        </div>
      </div>

      <!-- Row 6: Excerpt (full width) -->
      <div class="row">
        <div class="col-md-12 form-wrapper p-2">
          <el-form-item
            class=""
            :label="$t('COMMON.EXCERPT')"
            prop="excerpt"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 4 }"
              :placeholder="$t('COMMON.EXCERPT')"
              v-model="tax.excerpt"
            >
            </el-input>
          </el-form-item>
          <validation-error :errors="apiValidationErrors.excerpt" />
        </div>
      </div>

      <div class="submit-wrapper">
        <base-button
          type="button"
          class="btn btn-sm elite-submit"
          @click.prevent="checkTaxInformation"
          :disabled="loading || processing"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading || processing" />
          {{ tax.id ? $t("TAXES.EDIT_TAX") : $t("TAXES.ADD_TAX") }}
        </base-button>
      </div>
    </el-form>
    <modal :show="showTaxCheckModal" modal-classes="modal-secondary" size="lg">
      <div class="" slot="header">
        <h2 id="">
          {{ $t("COMMON.CONFIRMATION") }}
        </h2>
      </div>
      <div class="">
        <div class="row">
          <p class="text-lg text-center">
            {{
              $t("TAXES.SAME_TAXES", {
                name: tax.name,
              })
            }}
          </p>
        </div>
        <div class="page-wrapper-table-body">
          <div class="page-wrapper-table-body-inner">
            <el-table
              class="align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="taxes"
            >
              <div class="table-loading" slot="empty" v-if="loading">
                <img src="/img/loading.gif" alt="" />
              </div>
              <el-table-column
                :label="$t('COMMON.NAME')"
                min-width="250"
                prop="name"
              >
                <template v-slot="{ row }">
                  <span>
                    {{ `${row.name}` }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <template slot="footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="continueFormSubmitProcess"
          :disabled="loading || processing"
        >
          <span v-if="loading || processing" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("COMMON.CONTINUE") }}
        </button>

        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="toggleTaxCheckModalState"
          :disabled="loading || processing"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import {
  Option,
  Select,
  Table,
  TableColumn,
  Form,
  FormItem,
  Button,
  Checkbox,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import {
  TYPE_POURCENTAGE,
  TYPE_MONTANT_FIXE,
  TAXE_TYPES,
  TAXE_TRANSACTIONS_TYPES,
  CALCULATION_BASES,
} from "@/constants/taxes";

export default {
  layout: "DashboardLayout",

  components: {
    ValidationError,
    OrganizationSelector,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
  },

  mixins: [formMixin],

  props: {
    showOrganization: {
      type: Boolean,
      default: true,
    },
    taxData: {
      type: Object,
      default: () => ({}),
    },
    formErrors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideSubmit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    let taxData = { ...this.taxData };
    if (!taxData.organization) {
      taxData.organization = { type: "organizations", id: null };
    }
    if (!taxData.relationshipNames) {
      taxData.relationshipNames = ["organization"];
    }
    taxData = this.$fillUserOrganizationData(taxData);
    return {
      tax: taxData,
      calculationBases: CALCULATION_BASES,
      typePourcentage: TYPE_POURCENTAGE,
      typeMontantFixe: TYPE_MONTANT_FIXE,
      taxeTypes: TAXE_TYPES,
      taxeTransactions: TAXE_TRANSACTIONS_TYPES,
      taxes: [],
      total: 0,
      showModal: false,
      showTaxCheckModal: false,
      processing: false,
    };
  },

  methods: {
    async handleSubmit() {
      const checkUniqueTax = await this.checkTaxUniqueInformation();
      if (checkUniqueTax) {
        await this.sendInformation();
      } else {
        this.showTaxCheckModal = true;
      }
    },

    async sendInformation() {
      if (this.tax.name) {
        this.tax.name = this.tax.name.toString();
      }
      let taxData = cloneDeep(this.tax);
      taxData = this.$fillUserOrganizationData(taxData);
      this.$emit("taxSubmitted", taxData);
    },

    onFormChanged() {
      this.$emit("formChanged");
    },

    async getList() {
      if (!this.tax?.name) {
        return;
      }
      try {
        this.processing = true;
        let params = {
          filter: {
            search: `${this.tax?.name}`,
          },
          page: {
            number: 1,
            size: 999,
          },
        };
        await this.$store.dispatch("taxes/list", params);
        this.taxes = this.$store.getters["taxes/list"];
        this.total = this.$store.getters["taxes/listTotal"];
        this.processing = false;
      } catch (error) {
        this.processing = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async checkTaxUniqueInformation() {
      await this.getList();
      switch (this.total) {
        case 0:
          return true;
        case 1:
          return !!this.tax?.id;
        default:
          return false;
      }
    },

    async continueFormSubmitProcess() {
      this.processing = true;
      await this.toggleTaxCheckModalState();
      await this.sendInformation();
    },

    async toggleTaxCheckModalState() {
      this.showTaxCheckModal = !this.showTaxCheckModal;
    },

    checkTaxInformation() {
      this.$refs["taxForm"].validate(async (valid) => {
        if (valid) {
          if (this.tax.name) {
            this.handleSubmit();
            this.showModal = false;
          } else {
            this.showModal = true;
          }
        }
      });
    },

    async toggleModalState() {
      this.showModal = !this.showModal;
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    taxData(taxData) {
      if (taxData) {
        const cloned = cloneDeep(taxData);
        if (!cloned.organization) {
          cloned.organization = { type: "organizations", id: null };
        }
        if (!cloned.relationshipNames) {
          cloned.relationshipNames = ["organization"];
        }
        this.tax = {
          ...this.tax,
          ...cloned,
        };
      }
    },
  },
};
</script>
